import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-795f9741"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "row full-width" }
const _hoisted_5 = {
  key: 0,
  class: "col"
}
const _hoisted_6 = {
  key: 1,
  class: "col"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { id: "event-edit-scope-selector" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "input-label",
  for: "current"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "input-label",
  for: "all"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-5 text-right" }
const _hoisted_15 = { class: "col-5" }
const _hoisted_16 = ["readonly", "disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-5 text-right" }
const _hoisted_20 = { class: "col-5" }
const _hoisted_21 = ["readonly", "disabled"]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-5 text-right" }
const _hoisted_24 = { class: "col-5" }
const _hoisted_25 = ["readonly", "disabled", "placeholder"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-5 text-right" }
const _hoisted_28 = { class: "col-5" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-5 text-right" }
const _hoisted_31 = { class: "col-5" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-5 text-right" }
const _hoisted_34 = { class: "col-5" }
const _hoisted_35 = ["readonly", "disabled"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-5 text-right" }
const _hoisted_38 = { class: "col-5" }
const _hoisted_39 = ["readonly", "disabled"]
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col-5 text-right" }
const _hoisted_42 = { class: "col-5" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "row sub-topic" }
const _hoisted_45 = { class: "col-5 text-right" }
const _hoisted_46 = { for: "frequency" }
const _hoisted_47 = { class: "col-5 modal-input" }
const _hoisted_48 = { value: "daily" }
const _hoisted_49 = { value: "weekly" }
const _hoisted_50 = { value: "monthly" }
const _hoisted_51 = { class: "row sub-topic" }
const _hoisted_52 = { class: "col-5 text-right" }
const _hoisted_53 = { for: "frequency" }
const _hoisted_54 = { class: "col-5 modal-input" }
const _hoisted_55 = {
  key: 1,
  id: "delete-container",
  class: "row"
}
const _hoisted_56 = { class: "col-5 text-right" }
const _hoisted_57 = { class: "col-1 radio-input-wrapper" }
const _hoisted_58 = {
  key: 0,
  class: "col-5",
  id: "event-update-with-answer-alert"
}
const _hoisted_59 = { class: "modal-buttons" }
const _hoisted_60 = {
  key: 0,
  class: "btn primary",
  type: "submit"
}
const _hoisted_61 = ["readonly", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.mode === 'add')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("EVENT_MODAL.ADD")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mode === 'update')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("EVENT_MODAL.UPDATE")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.mode == 'update')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            id: "current",
                            class: "input-element",
                            type: "radio",
                            name: "range",
                            value: "current",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.range) = $event)),
                            checked: ""
                          }, null, 512), [
                            [_vModelRadio, _ctx.range]
                          ]),
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("EVENT_MODAL.CURRENT")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.mode == 'update')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            id: "all",
                            class: "input-element",
                            type: "radio",
                            name: "range",
                            value: "all",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.range) = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.range]
                          ]),
                          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("EVENT_MODAL.ALL")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("EVENT_MODAL.COLOR")), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.color) = $event)),
                        class: "form-select",
                        "aria-label": "event color",
                        readonly: !_ctx.editable || _ctx.toDelete,
                        disabled: !_ctx.editable || _ctx.toDelete,
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EVENTS_COLORS, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: c.name,
                            value: c.name
                          }, _toDisplayString(_ctx.$t("EVENT_MODAL.COLORS." + c.name.toUpperCase())), 9, _hoisted_17))
                        }), 128))
                      ], 8, _hoisted_16), [
                        [_vModelSelect, _ctx.color]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("EVENT_MODAL.TITLE")), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event)),
                        type: "text",
                        class: "full-width",
                        readonly: !_ctx.editable || _ctx.toDelete,
                        disabled: !_ctx.editable || _ctx.toDelete,
                        required: ""
                      }, null, 8, _hoisted_21), [
                        [_vModelText, _ctx.title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("EVENT_MODAL.CONTENT")), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.content) = $event)),
                        type: "text",
                        class: "full-width",
                        readonly: !_ctx.editable || _ctx.toDelete,
                        disabled: !_ctx.editable || _ctx.toDelete,
                        placeholder: _ctx.$t('EVENT_MODAL.PLACEHOLDER')
                      }, null, 8, _hoisted_25), [
                        [_vModelText, _ctx.content]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('EVENT_MODAL.STARTTIME')), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_Datepicker, {
                        modelValue: _ctx.start,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.start) = $event)),
                        "time-picker": "",
                        "is-24": "",
                        format: "HH:mm",
                        readonly: !_ctx.editable || _ctx.toDelete
                      }, null, 8, ["modelValue", "readonly"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('EVENT_MODAL.ENDTIME')), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_Datepicker, {
                        modelValue: _ctx.end,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.end) = $event)),
                        "time-picker": "",
                        "is-24": "",
                        format: "HH:mm",
                        readonly: !_ctx.editable || _ctx.toDelete
                      }, null, 8, ["modelValue", "readonly"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("EVENT_MODAL.ALL_DAY")), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.allDay) = $event)),
                        type: "checkbox",
                        readonly: !_ctx.editable || _ctx.toDelete,
                        disabled: !_ctx.editable || _ctx.toDelete
                      }, null, 8, _hoisted_35), [
                        [_vModelCheckbox, _ctx.allDay]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("EVENT_MODAL.COMPLETED")), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.completed) = $event)),
                        type: "checkbox",
                        readonly: !_ctx.editable || _ctx.toDelete,
                        disabled: !_ctx.editable || _ctx.toDelete
                      }, null, 8, _hoisted_39), [
                        [_vModelCheckbox, _ctx.completed]
                      ])
                    ])
                  ]),
                  (_ctx.mode == 'add')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("EVENT_MODAL.REPEAT")), 1),
                        _createElementVNode("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.repeat) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.repeat]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.repeat)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("EVENT_MODAL.FREQUENCY")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _withDirectives(_createElementVNode("select", {
                                  name: "frequency",
                                  id: "frequency",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.frequency) = $event))
                                }, [
                                  _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("EVENT_MODAL.DAILY")), 1),
                                  _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("EVENT_MODAL.WEEKLY")), 1),
                                  _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t("EVENT_MODAL.MONTHLY")), 1)
                                ], 512), [
                                  [_vModelSelect, _ctx.frequency]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("EVENT_MODAL.NUMBER_REPEATS")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "numberInput",
                                  type: "number",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.count) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.count]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.mode == 'update')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("EVENT_MODAL.DELETE")), 1),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              class: "input-element",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.toDelete) = $event)),
                              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeDeleteState()))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.toDelete]
                            ])
                          ])
                        ]),
                        (_ctx.hasAnswer && _ctx.toDelete)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("ALERTS.EVENTS.DELETE.WARNING_EXERCISE")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_59, [
                    (_ctx.mode === 'add')
                      ? (_openBlock(), _createElementBlock("button", _hoisted_60, _toDisplayString(_ctx.$t("EVENT_MODAL.ADD")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.mode === 'update')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn primary",
                          type: "submit",
                          readonly: !_ctx.editable,
                          disabled: !_ctx.editable
                        }, _toDisplayString(_ctx.$t("EVENT_MODAL.UPDATE")), 9, _hoisted_61))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancel()))
                    }, _toDisplayString(_ctx.$t("EVENT_MODAL.CANCEL")), 1)
                  ])
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}